import { ModuleWithProviders, NgModule } from '@angular/core';
import { GoliathContactsCRMFeatureModule } from '@digiwall/goliath-contacts/config';
import {
  GoliathDocumentsDeliveryFeatureModule,
  GoliathDocumentsLogisticFeatureModule,
  GoliathDocumentsPurchaseFeatureModule,
  GoliathDocumentsSaleFeatureModule,
  GoliathDocumentsStockFeatureModule,
  GoliathDocumentsSubscriptionFeatureModule,
} from '@digiwall/goliath-documents/config';
import {
  GoliathProductsProductionFeatureModule,
  GoliathProductsStockFeatureModule,
  GoliathServiceWorkOrderFeatureModule,
} from '@digiwall/goliath-products/config';
import { RoutePaths } from '../enums';

@NgModule({
  imports: [
    GoliathProductsStockFeatureModule.forRoot(),
    GoliathDocumentsStockFeatureModule.forRoot(),
    GoliathDocumentsSubscriptionFeatureModule.forRoot(),
    GoliathServiceWorkOrderFeatureModule.forRoot(),
    GoliathProductsProductionFeatureModule.forRoot(),
    GoliathContactsCRMFeatureModule.forRoot(),
    GoliathDocumentsSaleFeatureModule.forRoot(),
    GoliathDocumentsPurchaseFeatureModule.forRoot(),
    GoliathDocumentsDeliveryFeatureModule.forRoot(RoutePaths.Deliveries),
    GoliathDocumentsLogisticFeatureModule.forRoot(),
  ],
})
export class GoliathFeaturesConfigModule {
  static forRoot(): ModuleWithProviders<GoliathFeaturesConfigModule> {
    return {
      ngModule: GoliathFeaturesConfigModule,
    };
  }
}
